import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import type {
  CompetitorsState,
  BroadCompetitorData,
  DirectCompetitorData,
} from '../../components/competitors/types';

const initialState: CompetitorsState = {
  broadCompetitor: null,
  directCompetitors: [],
  loading: false,
  error: null,
};

const competitorsSlice = createSlice({
  name: 'competitors',
  initialState,
  reducers: {
    fetchCompetitorsRequest: (state, action: PayloadAction<string>) => {
      state.loading = true;
      state.error = null;
    },
    fetchCompetitorsSuccess: (
      state,
      action: PayloadAction<{
        broadCompetitor: BroadCompetitorData | null;
        directCompetitors: DirectCompetitorData[];
      }>
    ) => {
      state.loading = false;
      state.broadCompetitor = action.payload.broadCompetitor;
      state.directCompetitors = action.payload.directCompetitors;
      state.error = null;
    },
    fetchCompetitorsFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchCompetitorsRequest,
  fetchCompetitorsSuccess,
  fetchCompetitorsFailure,
} = competitorsSlice.actions;

export default competitorsSlice.reducer;
